<template>
    <v-container>
        <v-card>
            <v-card-title class="headline">Busqueda de empleado</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-text-field label="Busca el empleado por nombre, apellido o apodo" v-model="args"
                            @keyup.enter="searchEmployee" />
                    </v-col>
                </v-row>
                <v-row v-if="loadingSearchEmployee">
                    <v-col class="text-center">
                        <v-progress-circular width="2" size="60" indeterminate color="primary"></v-progress-circular>
                    </v-col>
                </v-row>

                <v-list>
                    <template v-for="(employee, key) in employees">
                        <v-list-item :key="key" v-if="employees.length > 0" @click="addEmployee(employee)">
                            <v-list-item-avatar>
                                <v-img :src="employee.photo_url ? employee.photo_url : photoEmpty"
                                    :lazy-src="employee.photo_thumb_url ? employee.photo_thumb_url : photoEmpty" />
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ employee.names }} / {{ employee.last_names
                                    }}</v-list-item-title>
                                <v-list-item-subtitle>{{ employee.avatar }}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{ employee.salary.toLocaleString('es-PE', {
                                    style:
                                        'currency', currency: 'PEN'
                                }) }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="employees.length - 1 != key" :key="`div${key}`" />
                    </template>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="default" @click="closeDialogSearchEmployee">cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {
    props: {
        employeeSelected: {
            type: Array,
            required: true,
            default: () => []
        },

        lider: {
            type: Number,
            required: false,
            default: 0
        },

        searchAll: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    data() {
        return {
            loadingSearchEmployee: false,
            employees: [],
            args: null,
        }
    },


    methods: {
        searchEmployee() {
            if (this.args.length >= 3) {
                this.loadingSearchEmployee = true;
                this.employees = [];
                let ids = "";
                let payload = {};


                this.employeeSelected.forEach(element => {
                    ids += element.id + ","
                });

                if (this.lider == 1) {
                    ids += this.lider + ",";
                }

                ids += "0";

                payload.args = this.args;
                payload.ids = ids

                let path = this.searchAll ? "findEmployessAllByArg" : "findEmployessNoPayRollAction";

                setTimeout(() => {
                    this.$store.dispatch(path, payload).then((res) => {
                        this.loadingSearchEmployee = false;
                        this.employees = res;
                    })
                }, 500);
            }
        },

        addEmployee(employee) {
            this.employees.splice(this.employees.indexOf(employee), 1);
            this.$emit("addEmployee", employee);
        },

        closeDialogSearchEmployee() {
            this.$emit("closeDialogSearchEmployee");
            this.employees = [];
            this.args = null;
            this.loadingSearchEmployee = false;
        }
    }
}
</script>